<template>
  <div class="container">
    <div class="row width_full">
      <div class="col_12">
        <div class="customer_content">
          <div class="common_subtitle pb_20">
            <h3 class="mb_0">Scroll Notice</h3>
            <router-link class="btn btn_success" style="float: right" :to="{name:'scroll_notice_add'}">Add New Scroll Notice</router-link>
          </div>
          <div class="row">
            <div class="col_12">
              <table-component
                  :columns="columns"
                  :rows="notices"
                  :header="true"
                  :centralized="true"
                  :sortable="sortable"
                  :pagination="pagination"
                  :searchShowStatus="true"
                  :perPageShowStatus="true"
                  @queryEvent="queryEvent"
                  @sorting="sorting"
                  @pageChanged="pageChanged">
                <template v-slot:image="{ row }">
                  <span class="color_blue item_size_delete">
                    <div class="form-group media_wrap" v-if="row.file_type == 'image'">
                      <img :src="row.image" alt=""   width="150">
                    </div>
                    <div class="form-group media_wrap" v-if="row.file_type == 'video'">
                      <video   width="150" :src="row.image" controls>
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  </span>
                </template>
                <template v-slot:action="{ row }">
                  <router-link :to="{name:'scroll_notice_edit', params:{id:row.id}}" class="btn btn_success"> Edit</router-link>
                  <span class="ml_10 btn btn_danger cursor_pointer" @click.prevent="deleteRecord(row)">Delete</span>
                </template>
              </table-component>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableComponent from "../../components/shared/TableComponent";
export default {
  name: "Index",
  components: {TableComponent},
  data(){
    return {
      notices: [],
      sort: '1',
      sortable: {
        order: 'id',
        sort: 'desc'
      },
      filter: {
        status: '',
        per_page: 10
      },
      columns: [
        {
          label: "Name",
          field: "title",
          sortable: true
        },
        {
          label: "Image",
          field: "image",
          sortable: false,
          slot: true,
        },
        {
          label: "Created Date",
          field: "created_at",
          sortable: false,
          slot: false,
        },
        {
          label: "Action",
          field: 'action',
          sortable: false,
          slot: true,
        }
      ],
      pagination: null,
      queryParams: {
        page: 1,
        per_page: 10,
        search: '',
        search_columns: 'name',
        sort: '',
        sort_order: '',
      },
    }
  },
  created() {
    this.loadData()
  },
  watch: {
    queryParams: {
      deep: true,
      handler() {
        this.loadData()
      }
    },
  },
  methods:{
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
    },
    pageChanged(page) {
      this.queryParams.page = page;
    },
    queryEvent(query){
      this.queryParams.search = query.search
      this.queryParams.per_page = query.per_page
    },
    loadData(){
      this.axios.get('/scroll-notices', {
        params: {...this.queryParams}
      }).then((response) => {
        this.notices = response.data.data;
        this.pagination = response.data.meta;
      })
    },
    deleteRecord(row) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/scroll-notices/'+row.id).then(() => {
            this.$swal.fire(
                'Deleted',
                'Notice has been deleted!',
                'success'
            )
            this.loadData();
          });
        }
      });
    },
  },
}
</script>
